import React from "react";
import { useCurrency } from "../context/CurrencyContext";

export function CostBreakdown({ product }) {
  const { format } = useCurrency();
  const { main, sub } = format(product.uk_price_ghs ?? product.delivered_ghs, product.uk_price_gbp ?? product.delivered_gbp);
  return (
    <div className="rounded-2xl bg-[#E7E1B1]/40 border border-[#0D530E]/8 p-5">
      <p className="text-xs tracking-[0.15em] uppercase font-semibold text-[#5C5C5C]">UK store price</p>
      <p className="font-display text-3xl text-[#0D530E] leading-none mt-1">{main}</p>
      <p className="text-sm text-[#5C5C5C] mt-1">{sub}</p>
      <p className="text-sm text-[#306D29] mt-3 border-t border-[#0D530E]/10 pt-3">
        No markup. Our shopping/handling fee &amp; weight-based shipping are added transparently at checkout.
      </p>
    </div>
  );
}
